import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsForgeAppsNextgenRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsForgeAppsNextgenRoute.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ForgeProjectSettingsPage, {
	LazyForgeProjectSettingsPage,
	forgeProjectSettingsPageResources,
} from './ui/project-settings/forge/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';

export const projectSettingsForgeAppsNextgenRouteEntry: Route = createEntry(
	projectSettingsForgeAppsNextgenRoute,
	() => ({
		group: 'project-settings-software',
		// eslint-disable-next-line no-restricted-syntax
		component: ForgeProjectSettingsPage,
		layout: softwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources(), ...forgeProjectSettingsPageResources()],
		forPaint: [LazyAtlassianNavigation, LazyForgeProjectSettingsPage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
